module.exports = __webpack_public_path__ + "img/ACEScg工作流.7c651550.gif";